module.exports = __webpack_public_path__ + "img/spine1.db2f0ee8.jpg";